/**
 * Shipping Parcel resource
 *
 * @name ShippingParcel
 * @class
 * @augments TmrResource
 */
export const factory = [
  'ShippingParcel',
  /*@ngInject*/ (TmrResource, ShippingNotice) => {
    let referencedProperties = [
      { property: 'shippingNotice', resource: ShippingNotice },
    ]
    const ShippingParcel = TmrResource(
      'ShippingParcel',
      {},
      referencedProperties
    )

    Object.defineProperty(ShippingParcel.prototype, '$outbound', {
      get: function () {
        return (
          this.shippingOperationParcels.find(
            ({ operationType }) => operationType === 'OUTBOUND'
          ) ?? null
        )
      },
    })

    Object.defineProperty(ShippingParcel.prototype, '$inbound', {
      get: function () {
        return (
          this.shippingOperationParcels.find(
            ({ operationType }) => operationType === 'INBOUND'
          ) ?? null
        )
      },
    })

    /**
     * Retrieves the most recent counters
     */
    Object.defineProperty(
      ShippingParcel.prototype,
      '$shippingOperationParcel',
      {
        get: function () {
          return this.shippingOperationParcels.sort(
            (a, b) => b.creationDate - a.creationDate
          )[0]
        },
      }
    )

    ShippingParcel.prototype.$counters = function (shippingOperationParcel) {
      shippingOperationParcel =
        shippingOperationParcel ?? this.$shippingOperationParcel
      if (shippingOperationParcel) {
        if (shippingOperationParcel.$counters === undefined)
          shippingOperationParcel.$counters = {}
        shippingOperationParcel.$counters.expected = 0
        shippingOperationParcel.$counters.unexpected = 0
        shippingOperationParcel.$counters.detected = 0
        shippingOperationParcel.$counters.missing = 0
        Object.keys(shippingOperationParcel.$counters).forEach(counter => {
          // Sum all counter types (epc, item...)
          shippingOperationParcel.$counters[counter] += Object.values(
            shippingOperationParcel.counters[`${counter}Counter`]
          ).reduce((count, curr) => count + curr, 0)
        })
        return shippingOperationParcel.$counters
      }
    }

    Object.defineProperty(ShippingParcel.prototype, '$outboundCounters', {
      get: function () {
        return this.$counters(this.$outbound)
      },
    })

    Object.defineProperty(ShippingParcel.prototype, '$inboundCounters', {
      get: function () {
        return this.$counters(this.$inbound)
      },
    })

    return ShippingParcel
  },
]
